module.exports = __webpack_public_path__ + "img/on-device-min.1b2afc0e.jpeg";